export default __webpack_public_path__ + "static/media/Capaweg.f6b6ece5.jpg";